// extracted by mini-css-extract-plugin
export var typingIndicator = "_ov-0";